export function scrollToId(id: string): void {
	document.querySelector(`[data-id="${id}"]`)?.scrollIntoView?.({ behavior: "smooth", block: "center" });
}
